export const globalSharedUS = {
  timezones: {
    zone: 'CST',
    travelDates: 'All travel dates are in CST',
  },
} as const;
